<template>
  <ContentSection spacing="none">
    <div
      class="relative flex"
      :class="
        data.orientation.value === 'left'
          ? 'flex-col md:flex-row'
          : 'flex-col md:flex-row-reverse'
      "
      :style="`background-color: ${data.background_color ?? ''};`"
    >
      <AppImage
        v-if="
          data.show_background_image_or_background_color?.value === 'image' &&
          data.backdrop_image
        "
        :asset="data.backdrop_image"
        class="absolute inset-0 -z-10 size-full object-cover"
      />
      <div
        class="w-full md:w-1/2"
        :class="data.orientation.value === 'left' ? 'md:mr-10' : 'md:ml-10'"
      >
        <AppImage
          v-if="data.show_image_or_video.value === 'image'"
          :asset="data.image_file"
          class="size-full bg-transparent object-contain"
          sizes="xs:90vw md:40vw"
        />

        <div v-if="data.show_image_or_video.value === 'video'">
          <VideoPlayer
            :video-id="videoId"
            :file="data.file"
            :poster="data.poster"
          />
        </div>
      </div>
      <div
        class="flex w-full flex-col justify-center bg-cover bg-center px-4 md:w-1/2 md:px-0"
        :class="
          data.orientation.value === 'left'
            ? 'lg:pl-0 lg:pr-8 xl:pr-16 2xl:-mr-1'
            : 'lg:pl-8 lg:pr-0 xl:pl-16 2xl:-ml-1'
        "
      >
        <div
          class="max-w-[clamp(770px,37vw,9999px)] py-12"
          :class="
            data.orientation.value === 'left'
              ? 'md:pl-1 md:pr-10 lg:pr-6'
              : 'ml-auto md:pl-10 md:pr-3 lg:pl-6'
          "
        >
          <h2
            v-if="data.title"
            class="mb-4 text-md font-bold md:text-xl lg:text-2xl"
          >
            {{ data.title }}
          </h2>
          <Bard
            v-if="data.text"
            :content="data.text"
            class="text-pretty text-base font-normal"
          />
        </div>
      </div>
    </div>
  </ContentSection>
</template>

<script setup lang="ts">
import type { AssetFragment } from '#gql'

const props = defineProps<{
  data: {
    title: string
    text?: string
    youtube_url?: string
    orientation: {
      value: string
    }
    show_image_or_video: {
      value: 'image' | 'video'
    }
    show_background_image_or_background_color: {
      value: 'image' | 'color'
    }
    background_color?: string
    backdrop_image: AssetFragment
    image_file?: AssetFragment
    file?: AssetFragment
    poster?: AssetFragment
  }
}>()

// Extract the video ID from the YouTube URL
const videoId = computed(() => {
  if (!props.data.youtube_url) return undefined

  const videoURL = props.data.youtube_url
  const splited = videoURL.split('v=')

  return splited[1]
})
</script>
